// `metaCountKey` below names which field of GET /nav-counts (see
// navCountsApi.js/navCounts.controller.js) this item's badge shows -
// useResolvedNavigation.js resolves it into the real `meta` string once
// the count has loaded. No `metaCountKey` (Products & Add Ons, Markets,
// Events) means that item never shows a badge, same as before.
export const defaultNavItems = [
  {
    menuItem: "Home",
    ddItems: [
      {
        menuItem: "Revenue",
        path: "/revenue",
        icon: { source: "mainNav", name: "Revenue" },
      },
    ],
  },
  {
    menuItem: "Customers",
    ddItems: [
      {
        menuItem: "Companies",
        path: "/company",
        icon: { source: "mainNav", name: "Companies" },
        metaCountKey: "companies",
      },
      {
        menuItem: "Contacts",
        path: "/contacts",
        icon: { source: "mainNav", name: "Contacts" },
        metaCountKey: "contacts",
      },
    ],
  },
  {
    menuItem: "Sell",
    path: "/sell",
    ddItems: [
      {
        menuItem: "Proposals",
        path: "/sell/proposals",
        icon: { source: "mainNav", name: "Proposals" },
        metaCountKey: "proposals",
      },
      {
        menuItem: "Self serve users",
        path: "/selfserveusers",
        icon: { source: "mainNav", name: "Self serve users" },
        metaCountKey: "selfServeUsers",
      },
      {
        menuItem: "Upsells / Downsells",
        path: "/upsellanddownsell",
        icon: { source: "mainNav", name: "Upsell / Downsell" },
        metaCountKey: "upsellDownsells",
      },
    ],
  },
  {
    menuItem: "Collect",
    path: "/collect",
    ddItems: [
      {
        menuItem: "Invoices",
        path: "/collect/invoice",
        icon: { source: "mainNav", name: "Invoices" },
        metaCountKey: "invoicesDue",
      },
      {
        menuItem: "Payments",
        path: "/collect/payments",
        icon: { source: "mainNav", name: "Payments" },
        metaCountKey: "payments",
      },
      {
        menuItem: "Subscriptions",
        path: "/subscriptions",
        icon: { source: "mainNav", name: "Subscriptions" },
        metaCountKey: "subscriptions",
      },
    ],
  },
  {
    menuItem: "Catalogue",
    path: "/catalogue",
    ddItems: [
      {
        menuItem: "Plans",
        path: "/configure/plans",
        icon: { source: "configureDropdown", name: "Plans" },
        metaCountKey: "plans",
      },
      {
        menuItem: "Products & Add Ons",
        path: "/configure/products",
        icon: { source: "configureDropdown", name: "Products & Add Ons" },
      },
      {
        menuItem: "Markets",
        path: "/configure/market",
        icon: { source: "configureDropdown", name: "Markets" },
      },
      {
        menuItem: "Events",
        path: "/configure/events",
        icon: { source: "configureDropdown", name: "Events" },
      },
    ],
  },
];
